export function normalizeHeaderValue(value: unknown): string | undefined {
  if (value === undefined || value === null) {
    return undefined;
  }

  const trimmed = String(value).trim();
  if (!trimmed) {
    return undefined;
  }

  const lower = trimmed.toLowerCase();
  if (lower === "undefined" || lower === "null") {
    return undefined;
  }

  return trimmed;
}

export function isGuid(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
}

export function normalizeGuidHeaderValue(value: unknown): string | undefined {
  const normalized = normalizeHeaderValue(value);
  if (!normalized) {
    return undefined;
  }

  return isGuid(normalized) ? normalized : undefined;
}
